import { render, staticRenderFns } from "./FlyoutDivider.vue?vue&type=template&id=06873ca2&"
import script from "./FlyoutDivider.vue?vue&type=script&lang=js&"
export * from "./FlyoutDivider.vue?vue&type=script&lang=js&"
import style0 from "./FlyoutDivider.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports